/** @format */

/**
 * Internal dependencies
 */
import { colorScales, selectionLimit } from '../../constants';
/**
 * External dependencies
 */

import { findIndex } from 'lodash';
export var getColor = function getColor(orderedKeys, colorScheme) {
  return function (key) {
    var len = orderedKeys.length > selectionLimit ? selectionLimit : orderedKeys.length;
    var idx = findIndex(orderedKeys, function (d) {
      return d.key === key;
    });
    var keyValue = idx <= selectionLimit - 1 ? colorScales[len][idx] : 0;
    return colorScheme(keyValue);
  };
};
//# sourceMappingURL=color.js.map